var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      staticClass: "w100",
      style: { height: "100%;" },
      attrs: { value: true, "escape-close": "" },
    },
    [_c("app-cashier-check-modal", { on: { close: _vm.close } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }